import SimpleStore from '../../../store/SimpleStore';
import { HTTP_URL_PARAMS } from '../../../utils/constants/HttpMethodsConstants';

const getEpisodeReqObject = (
  seasonId: string,
  selectedIndex: number,
  limit?: number,
  broadCastState?: boolean
) => {
  if (seasonId && seasonId.length) {
    const translation = SimpleStore.get(HTTP_URL_PARAMS.DISPLAY_LANGUAGE);
    const countryCode = SimpleStore.get(HTTP_URL_PARAMS.COUNTRY_CODE);
    const episodeFilter = {
      filter: {
        seasonId: seasonId,
        itemType: 'episode',
        onAir: broadCastState,
        page: selectedIndex,
        translation,
        country: countryCode,
        limit: limit || 10
      }
    };
    return episodeFilter;
  }
};

export default getEpisodeReqObject;
